// @ts-check
// Loja do editor E/OU sobre o rascunho de uma view (contrato 09 de público, seção 9): o FilterTreeEditor lê os signals
// do rascunho e despacha as ações para as mesmas funções do filtro avançado de sempre (view-state.js).
import {
  addAdvancedGroup,
  addAdvancedRule,
  getViewDraft,
  removeAdvancedGroup,
  removeAdvancedRule,
  setAdvancedGroupOperator,
  updateDraftFilter,
} from './view-state.js';

/**
 * @typedef {import('../../data/metadata-store.js').View} View
 * @typedef {import('../../lib/view-filters.js').ViewFilter} ViewFilter
 * @typedef {import('./view-state.js').ViewFilterGroup} ViewFilterGroup
 * @typedef {{ filters: import('@preact/signals').Signal<ViewFilter[]>, filterGroups: import('@preact/signals').Signal<ViewFilterGroup[]>,
 *   dispatch: (action: { type: string, [key: string]: any }) => void }} FilterTreeStore
 */

/**
 * @param {View} view
 * @returns {FilterTreeStore}
 */
export function createViewFilterStore(view) {
  const draft = getViewDraft(view);
  return {
    filters: draft.filters,
    filterGroups: draft.filterGroups,
    dispatch(action) {
      switch (action.type) {
        case 'addRule':
          addAdvancedRule(view, action.groupId, action.fieldMetadataId, action.operand);
          break;
        case 'addGroup':
          addAdvancedGroup(view, action.groupId, action.fieldMetadataId, action.operand);
          break;
        case 'updateFilter':
          updateDraftFilter(view, action.filterId, action.changes);
          break;
        case 'removeRule':
          removeAdvancedRule(view, action.filterId);
          break;
        case 'removeGroup':
          removeAdvancedGroup(view, action.groupId);
          break;
        case 'setGroupOperator':
          setAdvancedGroupOperator(view, action.groupId, action.logicalOperator);
          break;
        default:
          break;
      }
    },
  };
}

